/**
 *
 * ComplaintTag
 *
 */

import React, { memo } from 'react';
import styled from 'styled-components';

import { ErrorIcon } from 'assets/v2/icons';
import { COLORS } from '../../../../theme';
import Tag from '..';

const StyledTag = styled(Tag)`
  &.MuiChip-root {
    color: ${COLORS.redDark};
    background: ${COLORS.redLight};
    border-color: ${COLORS.red};
    border-radius: ${({ theme }) => theme.borderRadius.secondary};

    &&& .MuiChip-icon path {
      fill: ${COLORS.red};
    }
  }
`;

function ComplaintTag(props) {
  return <StyledTag label="Complaint" icon={<ErrorIcon />} {...props} />;
}

export default memo(ComplaintTag);
